import { render, staticRenderFns } from "./PriceModelDropdownField.vue?vue&type=template&id=be482b7a"
import script from "./PriceModelDropdownField.vue?vue&type=script&setup=true&lang=ts"
export * from "./PriceModelDropdownField.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be482b7a')) {
      api.createRecord('be482b7a', component.options)
    } else {
      api.reload('be482b7a', component.options)
    }
    module.hot.accept("./PriceModelDropdownField.vue?vue&type=template&id=be482b7a", function () {
      api.rerender('be482b7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/PriceModelDropdownField.vue"
export default component.exports